<div class="inputWrapper">
  <input
    id="{{ id }}"
    type="number"
    [value]="value"
    [min]="min"
    [max]="max"
    [placeholder]="placeholder"
    [ngClass]="{ error: errors }"
    (input)="validateInput($event)"
    [attr.maxlength]="maxLength"
  />
  @if (errors) {
    <div class="error-message">
      {{ errors }}
    </div>
  }
</div>
